module.exports = __webpack_public_path__ + "img/how-04.2bc0bd37.svg";